import { useCallback, useEffect } from 'react';
import { DeMinimisCheckController } from '@shared/components/form/DeMinimisCheckController';
import { DE_MINIMIS_THRESHOLD_NOK } from '@shared/services/stotteregisterApi';
import { useDemo, type DeMinimisCheckData } from './state';
import { DECISION_PROCESSING_MS, elapsedSince } from './decision';

export function ApplicationDeMinimisCheckController() {
  const { state, dispatch } = useDemo();
  const organizationNumber = state.project.organizationNumber.replace(/\D/g, '');
  const requestedAmount = state.funding.financing.requestedGrant;
  const onChange = useCallback((check: DeMinimisCheckData) => {
    dispatch({ type: 'SET_DE_MINIMIS_CHECK', check });
  }, [dispatch]);

  if (!state.loggedIn || state.submitted) return null;
  return (
    <DeMinimisCheckController
      key={`${organizationNumber}:${requestedAmount}:${state.deMinimisRetryCount}`}
      organizationNumber={organizationNumber}
      requestedAmount={requestedAmount}
      threshold={DE_MINIMIS_THRESHOLD_NOK}
      nokPerCurrencyUnit={1}
      onChange={onChange}
    />
  );
}

export function SubmissionDecisionController() {
  const { state, dispatch } = useDemo();

  useEffect(() => {
    if (state.decisionStatus !== 'processing' || !state.submittedAt) {
      return;
    }

    const remainingTime = Math.max(
      0,
      DECISION_PROCESSING_MS - elapsedSince(state.submittedAt)
    );
    const timeoutId = window.setTimeout(
      () => dispatch({ type: 'APPROVE_SUBMISSION' }),
      remainingTime
    );

    return () => window.clearTimeout(timeoutId);
  }, [dispatch, state.decisionStatus, state.submittedAt]);

  return null;
}
